export const NOT_ACCEPTED_TERMS_ERROR_MESSAGE = "Necessary terms have not been accepted";
